// src/pages/Dashboard.jsx
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import AuthContext from '../contexts/AuthContext';

/**
 * Smart Dashboard Component
 * Automatically redirects users to their role-specific dashboard
 * - Admin users -> Stays on /dashboard (or redirect to /admin/strategies)
 * - Officer users -> /officer/dashboard
 */
const Dashboard = () => {
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      // Redirect based on user role
      if (user.role === 'admin') {
        // Admin can stay on this page or redirect to their main admin page
        // For now, let's redirect to admin strategies page
        navigate('/admin/strategies', { replace: true });
      } else if (user.role === 'officer') {
        // Redirect officer to their dashboard
        navigate('/officer/dashboard', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  // Show loading while determining where to redirect
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <CircularProgress
        size={60}
        sx={{
          color: '#ffffff',
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        sx={{ color: '#ffffff', fontWeight: 600 }}
      >
        Redirecting to your dashboard...
      </Typography>
    </Box>
  );
};

export default Dashboard;
